import { render, staticRenderFns } from "./esimMailRecord.vue?vue&type=template&id=0cd6a84e&scoped=true"
import script from "./esimMailRecord.vue?vue&type=script&lang=js"
export * from "./esimMailRecord.vue?vue&type=script&lang=js"
import style0 from "./esimMailRecord.vue?vue&type=style&index=0&id=0cd6a84e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd6a84e",
  null
  
)

export default component.exports